import './App.css';
import Header from './Components /Header'
import AboutSection from './Components /AboutSection';
import Contact from './Components /Contact'
import About from './Components /About';
import Navbar from './Components /Navbar';
import ServicesList from './Components /ServicesList';

function App() {

  return (  
    
    <div className='App'>
       <Header/>
       <Navbar/>
       <main>
       <AboutSection/>
        <About/>
        <ServicesList/>
        <Contact/>
       </main>
       
    </div>
  
  );
}

export default App;
